import type { ProfileConfig } from '@/types/edit/ProfileConfig.ts';
import type { StepConfig } from '@/types/edit/StepConfig.ts';
import { StepConfigService } from '@/services/config/StepConfigService.ts';

export const getNeighbouringStepConfig = (
    profileConfigId: ProfileConfig['id'],
    stepConfigId: StepConfig['id'] | undefined,
    direction: 'next' | 'previous',
): StepConfig | undefined => {
    const stepConfig = stepConfigId ? StepConfigService.getStepConfig(stepConfigId) : undefined;
    const profileStepConfigs = Object.values(StepConfigService.getAllStepConfigs()).filter(
        (s) => s.profileId === profileConfigId,
    );

    let nextStepOrder = stepConfig?.order ?? 0;

    if (stepConfig === undefined) {
        nextStepOrder = 0;
    } else {
        if (direction === 'next') {
            nextStepOrder += 1;
        } else {
            nextStepOrder -= 1;
        }
    }

    return Object.values(profileStepConfigs).find((s) => s.order === nextStepOrder);
};
